import { CKInputChips, CKInputChipsProps } from 'clearkit';
import { FC } from 'react';

import { componentDisplayNames, Filter, FilterComposition } from './Filter';

type FilterInputChipsComposition = Omit<FilterComposition, 'Input'>;

const {
  helpTextDisplayName,
  iconDisplayName,
  titleDisplayName,
} = componentDisplayNames;

export const FilterInputChips: FC<CKInputChipsProps> &
  FilterInputChipsComposition = ({
  children,
  className,
  onChange,
  value,
  ...rest
}) => {
  const handleClearFilter = () => {
    onChange([]);
  };

  return (
    <Filter
      className={className}
      filterCount={value?.length}
      onClearFilter={handleClearFilter}
    >
      {children}
      <Filter.Input className="space-y-2">
        <CKInputChips
          {...rest}
          maxHeight="12rem"
          onChange={onChange}
          shouldOverflow={false}
          value={value}
        />
      </Filter.Input>
    </Filter>
  );
};

FilterInputChips.HelpText = Filter.HelpText;
FilterInputChips.HelpText.displayName = helpTextDisplayName;

FilterInputChips.Icon = Filter.Icon;
FilterInputChips.Icon.displayName = iconDisplayName;

FilterInputChips.Title = Filter.Title;
FilterInputChips.Title.displayName = titleDisplayName;
